<mat-expansion-panel [expanded]="true" showToggle="false" class="matExpansion-selected">
  <mat-expansion-panel-header class="disable_ripple">
    <mat-panel-title>
      <b class="disable_ripple_font">INDICATORS/STATUSES (FOR ALL GRADES)</b>
	  <help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_IndicatorsStatuses_Overview'"></help-text-btn>
    </mat-panel-title>

  </mat-expansion-panel-header>

  <form [formGroup]="frmIndicatorStatus">
    <div class="row">
      <!-- Current Parent/Guardian 1  Relationship  Phone 1-->

      <div class="col-3">
        <mat-label><b>PFS </b>
			<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_IndicatorsStatuses_PFS'"></help-text-btn>
        </mat-label>
        <mat-radio-group aria-label name="radioPFS" formControlName="radioPFS" id="radioPFS">
          <div class="row">
            <mat-radio-button [color]="'primary'" class="example-radio-button" value="1">Yes</mat-radio-button>
          </div>
          <div class="row">
            <mat-radio-button [color]="'primary'" class="example-radio-button" value="2">No</mat-radio-button>
          </div>
        </mat-radio-group>
      </div>
      <div class="col-3">
        <mat-label><b>Academic Risk</b>
			<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_IndicatorsStatuses_AcademicRisk'"></help-text-btn>
        </mat-label>
        <mat-radio-group aria-label name="radioAcademicRisk" formControlName="radioAcademicRisk" id="radioAcademicRisk">
          <div class="row">
            <mat-radio-button [color]="'primary'" class="example-radio-button" value="1">Yes</mat-radio-button>
          </div>
          <div class="row">
            <mat-radio-button [color]="'primary'" class="example-radio-button" value="2">No</mat-radio-button>
          </div>
        </mat-radio-group>
      </div>

      <div class="col-3">
        <mat-label><b>Special Education/IEP</b>
			<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_IndicatorsStatuses_SpecialEducationIEP'"></help-text-btn>
        </mat-label>
        <mat-radio-group aria-label name="radioSpecialEducation" formControlName="radioSpecialEducation"
          id="radioSpecialEducation">
          <div class="row">
            <mat-radio-button [color]="'primary'" class="example-radio-button" value="1">Yes</mat-radio-button>
          </div>
          <div class="row">
            <mat-radio-button [color]="'primary'" class="example-radio-button" value="2">No</mat-radio-button>
          </div>
        </mat-radio-group>
      </div>

      <div class="col-3">
        <mat-label><b>504 Plan</b>
			<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_IndicatorsStatuses_504Plan'"></help-text-btn>
        </mat-label>

        <mat-radio-group aria-label name="radio504" formControlName="radio504" id="radio504">
          <div class="row">
            <mat-radio-button [color]="'primary'" class="example-radio-button" value="1">Yes</mat-radio-button>
          </div>
          <div class="row">
            <mat-radio-button [color]="'primary'" class="example-radio-button" value="2">No</mat-radio-button>
          </div>
        </mat-radio-group>
      </div>
    </div>
  </form>

  <div class="row" style="padding-top: 30px" *ngIf="(action==2 || action==3) ">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Past Edit - {{this.trackHistories.inaHistory.length}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div *ngIf="this.trackHistories.inaHistory.length>=1">
          <app-past-edit [section]="this.section"></app-past-edit>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>


</mat-expansion-panel>